<template>
  <div>
    <ul class="lang-selector">
      <li class="lang">
        <a
          :class="{ active: currentLanguage('pl') }"
          class="menu-link d-flex"
          @click="setLang('pl')"
        >
          <span class="fi fi-pl" />
        </a>
      </li>
      <li class="lang">
        <a
          :class="{ active: currentLanguage('en') }"
          class="menu-link d-flex"
          @click="setLang('en')"
        >
          <span class="fi fi-gb" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import moment from 'moment'
import { useI18n } from 'vue-i18n'
import 'flag-icons/sass/flag-icons.scss'

export default defineComponent({
  name: 'LocaleChanger',
  setup() {
    const i18n = useI18n()
    i18n.locale.value = localStorage.getItem('lang') ? (localStorage.getItem('lang') as string) : 'pl'

    const setLang = (lang: string) => {
      localStorage.setItem('lang', lang)
      i18n.locale.value = lang
      moment.locale(lang)
    }

    const currentLanguage = (lang: string) => {
      return i18n.locale.value === lang
    }

    return {
      setLang,
      currentLanguage
    }
  }
})
</script>

<style lang="scss" scoped>
ul.lang-selector {
  list-style-type: none;
  background: #f5f8fa;
  padding: 0;
  text-align: center;
  border-radius: 0.475rem;
  border: 1px solid #ddd;

  li {
    display: inline-block;
    padding: 5px;

    &:hover {
      cursor: pointer;
    }

    a {
      cursor: pointer !important;
      pointer-events: auto !important;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      border-radius: 0.375rem;
      transition: all 0.2s ease;

      &:not(.active):hover {
        background-color: var(--primary-color);
        transform: scale(1.05);
      }

      &:active {
        transform: scale(0.95);
      }

      span {
        pointer-events: none;
      }
    }
  }
}
</style>